import { HttpHandler, HttpEvent, HttpRequest, HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { AuthService } from './auth.service';
import { Injectable } from "@angular/core";
import { mergeMap } from 'rxjs/operators';

@Injectable()
export class AuthTokenInterceptor {
  constructor(private http: HttpClient, private authService: AuthService) {

  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    console.log(`AddTokenInterceptor - ${req.url}`);
    return this.authService.getToken().pipe(mergeMap(token => {
      console.log('token', token);
      const result: HttpRequest<any> = token ? 
        req.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`
          }
        }) :
        req;
      return next.handle(result);
    }));
  }
}
